import React, { Fragment } from 'react';
import * as Render from '../platformui/Base/Render';
import ReferenceBlock from './reference-block';

const Blocks = {
  ReferenceBlock,
};

const ReferenceListBlock = (props) => {
  const referenceListItem = (
    <Render.Block
      blocks={props.References}
      propertyName="References"
      currentPageProps={props}
    >
      <Render.BlockTypeRenderer Blocks={Blocks} />
    </Render.Block>
  );

  return (
    <Fragment>
      <h3 className="reference__list-heading">{props.Heading}</h3>

      {props.ShowNumberedList ? (
        <ol className="reference__list">{referenceListItem}</ol>
      ) : (
        <ul className="reference__list">{referenceListItem}</ul>
      )}
    </Fragment>
  );
};

export default ReferenceListBlock;